<template>
  <v-card class="text-center" outlined tile>
    <v-badge bordered inline color="transparent" offset-x="10" offset-y="10">
      <CajaPaleta class="ml-1 mr-1" /> x
    </v-badge>
  </v-card>
</template>

<script>
import { CajaPaleta } from "../Icons";

export default {
  components: { CajaPaleta },
};
</script>

<style></style>
